import { AirlineLogo } from '@/src/utils/confirmation/airlineUtils'
import { Box, Card, Chip, Typography } from '@mui/material'
import RichText from '@/src/components/common/RichText'

interface ProcessedAirline {
    airlineCode: string
    airlineName: string
    summary: string
    strengths: string[]
    logoUrl: string
}

interface AirlineComparisonProps {
    airlines: ProcessedAirline[]
}

const AirlineComparison: React.FC<AirlineComparisonProps> = ({ airlines }) => {
    return (
        <Box sx={{ mb: 3 }}>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
                    gap: 2
                }}
            >
                {airlines.map(airline => (
                    <Card
                        key={airline.airlineCode}
                        sx={{
                            p: 2,
                            borderRadius: 1.5,
                            border: 1,
                            borderColor: 'grey.200',
                            boxShadow: 'none'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
                            <AirlineLogo airlineCode={airline.airlineCode} width={32} height={24} />
                            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                {airline.airlineName}
                            </Typography>
                        </Box>
                        <RichText html={airline.summary} variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }} />
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {airline.strengths.map((strength, index) => (
                                <Chip
                                    key={index}
                                    size="small"
                                    label={strength}
                                    sx={{ bgcolor: 'grey.100', fontSize: '0.75rem' }}
                                />
                            ))}
                        </Box>
                    </Card>
                ))}
            </Box>
        </Box>
    )
}

export default AirlineComparison
export type { AirlineComparisonProps }
